// Reuben Tucker bespoke site behaviour (ported from the design prototype).
// Multi-page adaptation: no SPA hash-routing — each behaviour guards on the
// presence of its markup so it is a no-op on templates that don't use it.

export default function rtSite() {
    "use strict";

    // ---- nav underbar: mark the active item by URL, slide the blue bar under it ----
    var nav = document.querySelector("nav.primary");
    var underline = nav ? nav.querySelector(".nav-underline") : null;
    var norm = function (p) { return p.replace(/\/+$/, "") || "/"; };

    function setActiveNav() {
        if (!nav || !underline) return;
        var here = norm(location.pathname);
        var active = null;
        nav.querySelectorAll("a").forEach(function (a) {
            var p = norm(new URL(a.href).pathname);
            if (p === here) { a.setAttribute("aria-current", "page"); if (a.offsetParent !== null) active = a; }
            else { a.removeAttribute("aria-current"); }
        });
        // the phone copy of Join sits outside the nav; mark it too so CSS can underline it
        var joinM = document.querySelector(".enquire-m");
        if (joinM) {
            if (norm(new URL(joinM.href).pathname) === here) joinM.setAttribute("aria-current", "page");
            else joinM.removeAttribute("aria-current");
        }
        if (active) {
            // under a link: full width, blue; inside the Join button: 90% wide, white, 2px up
            var btn = active.classList.contains("nav-join");
            underline.style.opacity = 1;
            underline.style.width = (btn ? active.offsetWidth * 0.9 : active.offsetWidth) + "px";
            underline.style.transform = "translateX(" + (active.offsetLeft + (btn ? active.offsetWidth * 0.05 : 0)) + "px)";
            underline.style.bottom = (nav.offsetHeight - active.offsetTop - active.offsetHeight + (btn ? 2 : 0)) + "px";
            underline.style.backgroundColor = btn ? "#fff" : "";
        } else {
            underline.style.opacity = 0;
        }
    }
    setActiveNav();
    // place without animating on first paint, then enable the slide (for resize)
    requestAnimationFrame(function () {
        requestAnimationFrame(function () { if (underline) underline.classList.add("ready"); });
    });
    window.addEventListener("resize", setActiveNav);
    // if the web font lands after first layout the links shift; re-measure without sliding
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
            if (!underline) return;
            var had = underline.classList.contains("ready");
            underline.classList.remove("ready");
            setActiveNav();
            void underline.offsetWidth;
            if (had) underline.classList.add("ready");
        });
    }

    // ---- countdown to the 2027 Fiesta Junior opener ----
    if (document.querySelector("[data-cu]")) {
        var target = new Date("2027-04-10T09:00:00");
        var pad = function (n) { return (n < 10 ? "0" : "") + n; };
        var tick = function () {
            var ms = target - new Date(); if (ms < 0) ms = 0;
            var s = Math.floor(ms / 1000);
            var vals = {
                d: Math.floor(s / 86400),
                h: pad(Math.floor(s % 86400 / 3600)),
                m: pad(Math.floor(s % 3600 / 60)),
                s: pad(s % 60)
            };
            Object.keys(vals).forEach(function (k) {
                var el = document.querySelector('[data-cu="' + k + '"]');
                if (el) el.textContent = vals[k];
            });
        };
        tick(); setInterval(tick, 1000);
    }

    // ---- pinned sub-nav bars: keep sticky offset synced to the header's
    // real height. header.site wraps to two rows and grows taller below
    // 860px, so a fixed CSS top value would put a pinned bar right under
    // the taller header — since both are sticky and the header has the
    // higher z-index, it would cover the bar's top edge once scrolled,
    // making a "fixed" strip look like it scrolled away. Applies to any
    // bar marked [data-pin]: Pathway's stage strip, Partners' sub-nav.
    var siteHeader = document.querySelector("header.site");
    var pinnedBars = document.querySelectorAll("[data-pin]");
    var syncPinnedTops = function () {
        if (!siteHeader) return;
        var h = siteHeader.offsetHeight + "px";
        pinnedBars.forEach(function (bar) { bar.style.top = h; });
    };
    if (pinnedBars.length) {
        syncPinnedTops();
        window.addEventListener("resize", syncPinnedTops);
        window.addEventListener("orientationchange", syncPinnedTops);
        window.addEventListener("load", syncPinnedTops);
        // follow the header's real size whenever it changes (rotation, font swap,
        // nav re-wrap): a resize event can fire before the new layout settles and
        // leave a stale height, which hid the strip under the header or left a gap
        if (window.ResizeObserver && siteHeader) new ResizeObserver(syncPinnedTops).observe(siteHeader);
    }

    // ---- pathway timeline: progress fill + click-to-scroll + scrollspy ----
    if (document.querySelector(".tl")) {
        var pwPin = document.querySelector("#pg-pathway .tl-pin");
        var setTimeline = function (activeStage) {
            document.querySelectorAll(".tl button").forEach(function (b) {
                var n = +b.getAttribute("data-tl");
                b.classList.toggle("done", n < activeStage);
                b.classList.toggle("now", n === activeStage);
            });
            // fill the connector up to the ACTIVE dot, which stays unfilled itself (dots sit 20% apart)
            var prog = document.querySelector(".tl-progress");
            if (prog) prog.style.width = (Math.max(0, activeStage - 1) * 20) + "%";
        };
        var scrollToStage = function (s) {
            if (!s) return;
            // anchor on .shead, not h3 — the big stage number is the tallest child
            // (flex-end aligned), so .shead's own top edge is the number's top edge
            var shead = s.querySelector(".shead") || s;
            var num = s.querySelector(".num");
            var sticky = (siteHeader ? siteHeader.offsetHeight : 0) + (pwPin ? pwPin.offsetHeight : 0);
            var spacer = num ? num.offsetHeight / 2 : 0;
            var off = sticky + spacer;
            var y = window.pageYOffset + shead.getBoundingClientRect().top - off;
            window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
        };
        document.querySelectorAll(".tl button").forEach(function (b) {
            b.addEventListener("click", function () {
                scrollToStage(document.getElementById("stage-" + b.getAttribute("data-tl")));
            });
        });
        var obs = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
                if (e.isIntersecting) { setTimeline(+e.target.getAttribute("data-stage")); }
            });
        }, { rootMargin: "-30% 0px -55% 0px" });
        document.querySelectorAll(".stage").forEach(function (s) { obs.observe(s); });
        setTimeline(1);
    }

    // ---- partners page: Pitch/Numbers sub-nav (click-to-scroll + scrollspy) ----
    var pn = document.querySelector(".pt-subnav");
    if (pn) {
        var setSubnav = function (id) {
            pn.querySelectorAll("button").forEach(function (b) {
                b.classList.toggle("now", b.getAttribute("data-pn") === id);
            });
        };
        var scrollToSection = function (id) {
            var el = document.getElementById(id);
            if (!el) return;
            // the first tab is the top of the page: go all the way up rather
            // than stopping a few px short with the heading tucked under the bars
            if (id === "pitch") {
                window.scrollTo({ top: 0, behavior: "smooth" });
                return;
            }
            var off = (siteHeader ? siteHeader.offsetHeight : 0) + pn.offsetHeight;
            // land with roughly half the section's own top padding still
            // showing as breathing room below the sub-nav, rather than
            // flush against it (both #pitch's .pt-hero and #numbers'
            // .rn-hero start with a wrap that carries that padding)
            var firstWrap = el.querySelector(":scope > .wrap");
            var padTop = firstWrap ? parseFloat(getComputedStyle(firstWrap).paddingTop) || 0 : 0;
            var y = window.pageYOffset + el.getBoundingClientRect().top - off + padTop / 2;
            window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
        };
        pn.querySelectorAll("button").forEach(function (b) {
            b.addEventListener("click", function () {
                scrollToSection(b.getAttribute("data-pn"));
            });
        });
        // in-page links to a tab's section (e.g. the "The partnership case"
        // button at the foot of the page): a bare #anchor jump parks the
        // section's top edge under the sticky header and sub-nav, so take it
        // through the same offset-aware scroll as the tabs
        document.querySelectorAll('a[href="#pitch"], a[href="#numbers"], a[href="#backers"]').forEach(function (a) {
            a.addEventListener("click", function (e) {
                e.preventDefault();
                scrollToSection(a.getAttribute("href").slice(1));
            });
        });
        // "See exactly what you get" (#pitch) jumps past #numbers' own hero/
        // year-one/differentiators straight to the deliverables table --
        // sub-nav-aware offset like scrollToSection above, but lands AT the
        // "Every deliverable..." heading rather than the top of #deliverables'
        // own 8vh top padding (scrollToSection instead keeps HALF a nested
        // .wrap's padding as breathing room for top-level tab jumps, which
        // isn't what a jump straight to one heading should do here).
        var jumpDeliverables = document.getElementById("jump-deliverables");
        if (jumpDeliverables) {
            jumpDeliverables.addEventListener("click", function (e) {
                e.preventDefault();
                var el = document.getElementById("deliverables");
                if (!el) return;
                var off = (siteHeader ? siteHeader.offsetHeight : 0) + pn.offsetHeight;
                var padTop = parseFloat(getComputedStyle(el).paddingTop) || 0;
                // land 24px short of the heading's own top edge -- skipping
                // the FULL padTop put it flush against the sticky sub-nav
                // with no breathing room at all ("too close to the title")
                var y = window.pageYOffset + el.getBoundingClientRect().top + padTop - off - 24;
                window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
            });
        }
        var pnObs = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
                if (e.isIntersecting) { setSubnav(e.target.id); }
            });
        }, { rootMargin: "-40% 0px -55% 0px" });
        ["pitch", "numbers", "backers"].forEach(function (id) {
            var el = document.getElementById(id);
            if (el) pnObs.observe(el);
        });
        setSubnav("pitch");
    }

    // ---- global back-to-top button ----
    var toTop = document.querySelector(".totop");
    if (toTop) {
        var toggleToTop = function () {
            toTop.classList.toggle("show", window.scrollY > 500);
        };
        toggleToTop();
        window.addEventListener("scroll", toggleToTop, { passive: true });
        toTop.addEventListener("click", function () {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
    }

    // ---- partner ROI break-even calculator (The Return page) ----
    var calc = document.getElementById("roi-calc");
    if (calc) {
        var gbp = new Intl.NumberFormat("en-GB", {
            style: "currency", currency: "GBP", maximumFractionDigits: 0
        });
        var amount = document.getElementById("rc-amount");
        var taxSel = document.getElementById("rc-tax");
        var custVal = document.getElementById("rc-value");
        var margin = document.getElementById("rc-margin");
        var tierBtns = calc.querySelectorAll(".rn-tiers button");
        var put = function (key, text) {
            var el = calc.querySelector('[data-rc="' + key + '"]');
            if (el) el.textContent = text;
        };

        var recalc = function () {
            var gross = Math.max(0, +amount.value || 0);
            var rate = +taxSel.value || 0;
            var value = Math.max(0, +custVal.value || 0);
            // clamp margin to 1-100 so a stray 0 or 900 can't produce nonsense
            var marg = Math.min(100, Math.max(1, +margin.value || 0)) / 100;

            var relief = gross * rate;
            var net = gross - relief;
            var profit = value * marg;
            // no margin or no customer value means there is no meaningful hurdle to show
            var breakeven = profit > 0 ? Math.ceil(net / profit) : 0;

            put("gross", gbp.format(gross));
            put("relief", (relief > 0 ? "−" : "") + gbp.format(relief));
            put("net", gbp.format(net));
            // a 12-month season, matching the break-even line below
            put("grossmo", gbp.format(Math.round(gross / 12)));
            put("netmo", gbp.format(Math.round(net / 12)));
            put("profit", gbp.format(profit));
            put("breakeven", profit > 0 ? breakeven : "-");
            put("three", profit > 0 ? Math.ceil(net * 3 / profit) : "-");
            put("permonth", profit > 0
                ? "that's " + (breakeven / 12).toFixed(1).replace(/\.0$/, "") +
                  " a month across a 12-month season"
                : "enter a customer value and margin to see the hurdle");

            // highlight whichever tier button matches the current amount, if any
            tierBtns.forEach(function (b) {
                b.classList.toggle("on", +b.getAttribute("data-amt") === gross);
            });
        };

        tierBtns.forEach(function (b) {
            b.addEventListener("click", function () {
                amount.value = b.getAttribute("data-amt");
                recalc();
            });
        });
        [amount, taxSel, custVal, margin].forEach(function (el) {
            el.addEventListener("input", recalc);
            el.addEventListener("change", recalc);
        });
        recalc();
    }

    // ---- contact form: POST to the Cloudflare Worker relay (see worker/) ----
    var form = document.getElementById("contactform");
    if (form) {
        var endpoint = form.getAttribute("data-endpoint");
        var errBox = form.querySelector(".err");
        var sendBtn = form.querySelector("button[type=submit]");
        form.addEventListener("submit", function (ev) {
            ev.preventDefault();
            if (!form.checkValidity()) { form.reportValidity(); return; }
            form.classList.remove("iserr");
            sendBtn.disabled = true;
            sendBtn.textContent = "Sending…";
            var tsField = form.querySelector('[name="cf-turnstile-response"]');
            var data = {
                name: form.name.value,
                email: form.email.value,
                phone: form.phone.value,
                company: form.company.value,
                message: form.message.value,
                turnstileToken: tsField ? tsField.value : "",
            };
            fetch(endpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            })
                .then(function (res) { return res.json().then(function (body) { return { ok: res.ok, body: body }; }); })
                .then(function (result) {
                    if (result.ok && result.body.ok) {
                        form.classList.add("issent");
                    } else {
                        throw new Error(result.body.error || "Send failed");
                    }
                })
                .catch(function (err) {
                    errBox.textContent = (err && err.message) ||
                        "Something went wrong sending your enquiry - please try again, or email partners@reubenracing.uk directly.";
                    form.classList.add("iserr");
                    sendBtn.disabled = false;
                    sendBtn.textContent = "Send enquiry";
                    if (window.turnstile) { window.turnstile.reset(); }
                });
        });
    }

    // ---- Legal page: cookieless analytics opt-out (Matomo) ----
    var optoutBtn = document.getElementById("lg-analytics-optout");
    if (optoutBtn) {
        var OPTOUT_KEY = "rtr_analytics_opt_out";
        var isOptedOut = function () {
            try { return localStorage.getItem(OPTOUT_KEY) === "1"; } catch (e) { return false; }
        };
        var renderOptout = function () {
            optoutBtn.textContent = isOptedOut()
                ? "You're opted out - click to opt back in"
                : "Opt out of analytics";
        };
        optoutBtn.addEventListener("click", function () {
            var wasOptedOut = isOptedOut();
            try {
                if (wasOptedOut) { localStorage.removeItem(OPTOUT_KEY); }
                else { localStorage.setItem(OPTOUT_KEY, "1"); }
            } catch (e) { /* storage unavailable - button still reflects the click below */ }
            if (window._paq) {
                window._paq.push([wasOptedOut ? "forgetUserOptOut" : "optUserOut"]);
            }
            renderOptout();
        });
        renderOptout();
    }
}
